export default __webpack_public_path__ + "img/footer-d13a3cca.png";